import { helper } from '@ember/component/helper';

export const toUpperCase = (params) => (params[0] || '').toUpperCase();

export default helper(toUpperCase);
